import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import DefaultButton from "../../../shared/components/DefaultButton";
import { instance } from "../../../shared/utilites/ApiClient";

const CreateNewPassword = () => {
    const markPath = "/mark-dark.png";
    let { key } = useParams();
    const [searchParams] = useSearchParams();
    let employee_id = searchParams.get('id');
    let isExpire = searchParams.get('Expire');

    let [message, setMessage] = useState('');
    let [errorMsg, setErrorMsg] = useState('');

    const validate = (values) => {
        let errors = {};
        if (!values.password) {
            errors.password = "Password cannot be blank"
        } else if (values.password.length < 9) {
            errors.password = "Password too short"
        } else if (!/[A-Z]/.test(values.password)) {
            errors.password = "Password must contain an uppercase letter"
        } else if (!/[a-z]/.test(values.password)) {
            errors.password = "Password must contain a lowercase letter"
        } else if (!/\d/.test(values.password)) {
            errors.password = "Password must contain a number"
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.password)) {
            errors.password = "Password must contain at least one special character"
        }
        if (values.password !== values.password2) {
            errors.password2 = "Passwords do not match"
        }
        return errors;
    }

    const submit = (values) => {
        instance.post("/login/changePassword", { password: values.password, key, employee_id: employee_id }).then(response => {
            if (response?.data?.msg?.error_code === 'RES_001') {
                setErrorMsg(response?.data?.msg?.error);
            } else {
                setErrorMsg('');
                setMessage(response?.data?.msg);
            }
        }).catch(e => {
            setErrorMsg('');
            setMessage(e?.response?.data?.msg)
        })
    }

    const lockIcon = (
        <svg className="login-input-icon" viewBox="0 0 24 24">
            <rect x="5" y="11" width="14" height="9" rx="2" />
            <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </svg>
    );

    return (
        <div className="login-page login-page--light login-page--top">
            <div className="login-shell login-shell--single">
                <div className="login-card">
                    <div className="login-brand">
                        <img src={markPath} alt="" aria-hidden="true" className="login-logo" />
                        <h1>Create New Password</h1>
                        <p>Choose a new password for your account</p>
                    </div>

                    {isExpire && message === '' && (
                        <div className="login-alert">
                            Your password has expired. Please change it to continue.
                        </div>
                    )}

                    {errorMsg !== '' && (
                        <div className="login-alert">{errorMsg}</div>
                    )}

                    {message ? (
                        <div className="login-success">{message}</div>
                    ) : (
                        <Formik
                            validate={validate}
                            initialValues={{ password: "", password2: "" }}
                            onSubmit={submit}
                        >
                            {({ errors, touched }) => (
                                <Form>
                                    <div className="login-field">
                                        <label htmlFor="emp_id">Employee ID</label>
                                        <div className="login-input-wrap">
                                            <svg className="login-input-icon" viewBox="0 0 24 24">
                                                <circle cx="12" cy="8" r="4" />
                                                <path d="M4 20c1.5-4 4.5-6 8-6s6.5 2 8 6" />
                                            </svg>
                                            <input
                                                id="emp_id"
                                                className="login-input"
                                                value={employee_id || ""}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="login-field">
                                        <label htmlFor="password">New Password</label>
                                        <div className="login-input-wrap">
                                            {lockIcon}
                                            <Field
                                                id="password"
                                                name="password"
                                                type="password"
                                                placeholder="Enter new password"
                                                autoComplete="new-password"
                                                autoFocus
                                                className={`login-input ${touched.password && errors.password ? "is-invalid" : ""}`}
                                            />
                                        </div>
                                        <ErrorMessage name="password" component="div" className="login-error" />
                                    </div>

                                    <div className="login-field">
                                        <label htmlFor="password2">Confirm Password</label>
                                        <div className="login-input-wrap">
                                            {lockIcon}
                                            <Field
                                                id="password2"
                                                name="password2"
                                                type="password"
                                                placeholder="Re-enter new password"
                                                autoComplete="new-password"
                                                className={`login-input ${touched.password2 && errors.password2 ? "is-invalid" : ""}`}
                                            />
                                        </div>
                                        <ErrorMessage name="password2" component="div" className="login-error" />
                                    </div>

                                    <div className="login-hint">
                                        Password must contain at least:
                                        <ul>
                                            <li>9 characters</li>
                                            <li>One uppercase letter</li>
                                            <li>One lowercase letter</li>
                                            <li>One number</li>
                                            <li>One special character</li>
                                        </ul>
                                    </div>

                                    <DefaultButton
                                        buttonTitle="Reset"
                                        buttonClass="default-btn-color login-btn"
                                        buttonType="submit"
                                    />
                                </Form>
                            )}
                        </Formik>
                    )}

                    <a href="https://wireless-vision.helpjuice.com" className="login-back">← Back to Login</a>
                </div>
            </div>
        </div>
    );
};

export default CreateNewPassword;